import src from "IMAGE";
export default { src, width: 197, height: 99, blurWidth: 8, blurHeight: 4, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAYAAACzzX7wAAAAS0lEQVR42n2NOwqAMBTAev+buQhuRaoPf/gZtFoUQUsKXbo1Q6ZAFHl+Fe12rC5Yp4ahr3Gm5LNbCvx98rQV89ghIixG815HCnKLAPtDfAmCzPkGAAAAAElFTkSuQmCC"};
